import styled from "styled-components";

const colors = {
  textPrimary: "#172B4D",
  textSecondary: "#6B778C",
  border: "#DFE1E6",
  danger: "#c62828",
  dangerHover: "#b71c1c",
  warningBg: "#FFF4E5",
  warningText: "#8A5A00",
};

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 28px 32px 24px;
  box-sizing: border-box;
  color: ${colors.textPrimary};
`;

export const CloseButtonIcon = styled.button`
  position: absolute;
  top: 12px;
  right: 14px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${colors.textSecondary};
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f1f3f5;
    color: ${colors.textPrimary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Title = styled.h2`
  margin: 0;
  padding-right: 28px;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.2;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 110px;
  border: 1px solid ${colors.border};
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;
  color: ${colors.textPrimary};
  box-sizing: border-box;

  &::placeholder {
    color: #9aa3b2;
  }

  &:focus {
    outline: none;
    border-color: ${colors.danger};
    box-shadow: 0 0 0 3px rgba(198, 40, 40, 0.12);
  }

  &:disabled {
    background: #f8f9fa;
  }
`;

export const WarningBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: ${colors.warningBg};
  color: ${colors.warningText};
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 600;
`;

export const WarningIcon = styled.span`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 1px;
  border-radius: 50%;
  border: 1.5px solid ${colors.warningText};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
`;

export const ActionsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 4px;
`;

export const ConfirmRejectButton = styled.button`
  height: 44px;
  border: none;
  border-radius: 10px;
  background: ${colors.danger};
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: ${colors.dangerHover};
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled.button`
  height: 44px;
  border: 1.5px solid ${colors.border};
  border-radius: 10px;
  background: #fff;
  color: ${colors.textPrimary};
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: #f7f7f7;
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;
